import { useState } from 'react';

import usePagination from '@hooks/usePagination';
import { NOTICE_LIST_DATA } from '@lib/DUMMY';

import { Wrapper } from '@components/styled/StyledComponents';
import { TableBody, EmptyTable } from '@components/share/Table/table.style';
import Headline from '@components/layout/Headline';
import FilterButtons from '@components/layout/FilterButtons';
import NoticeListRow from '@components/features/Notice/NoticeListRow';
import Loader from '@components/share/Loader';
import Pagination from '@components/layout/Pagination';

const Notice = () => {
    const [loading, setLoading] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(0);
    // 페이지네이션 관련 상태
    const [take, setTake] = useState(8);
    const [preCursor, setPreCursor] = useState(0);
    const [nextCursor, setNextCursor] = useState(0);
    const [cursorOption, setCursorOption] = useState<boolean | null>(null);

    const totalLength = NOTICE_LIST_DATA.length;
    const importantLists =
        NOTICE_LIST_DATA.filter((data) => data.important) || [];
    const noticeLists =
        NOTICE_LIST_DATA.filter((data) => !data.important) || [];
    // 페이지네이션
    const {
        pageIndex,
        setPageIndex,
        pageGroupLength,
        prevPageHandler,
        nextPageHandler,
        prevPageGroupHandler,
        nextPageGroupHandler,
        resetPaginationHandler,
        disabled
    } = usePagination(
        take,
        totalLength,
        setPreCursor,
        setNextCursor,
        setCursorOption,
        NOTICE_LIST_DATA, // TODO: 임시
        'id' // TODO: 임시
    );

    if (loading) return <Loader />;

    return (
        <Wrapper>
            <Headline title="공지사항" />
            {importantLists.length > 0 && (
                <TableBody $margin="0 0 12px">
                    {importantLists.map((data, idx) => (
                        <NoticeListRow
                            key={`${idx}-notice-important`}
                            data={data}
                        />
                    ))}
                </TableBody>
            )}
            <TableBody $height={72 * 8}>
                {noticeLists.length === 0 ? (
                    <EmptyTable>공지사항이 없습니다.</EmptyTable>
                ) : (
                    noticeLists
                        .slice(
                            pageGroupLength + pageIndex,
                            pageGroupLength + pageIndex + take
                        )
                        .map((data, idx) => (
                            <NoticeListRow
                                key={`${idx}-notice-list`}
                                data={data}
                            />
                        ))
                )}
            </TableBody>
            <Pagination
                take={take}
                pageIndex={pageIndex}
                setPageIndex={setPageIndex}
                pageGroupLength={pageGroupLength}
                totalLength={totalLength}
                prevPageHandler={prevPageHandler}
                nextPageHandler={nextPageHandler}
                prevPageGroupHandler={prevPageGroupHandler}
                nextPageGroupHandler={nextPageGroupHandler}
                resetPaginationHandler={resetPaginationHandler}
                disabled={disabled}
                BORDER
            />
        </Wrapper>
    );
};

export default Notice;
